// Logging utility no longer relies on Sentry

enum EFeature1Context {
    visitor = 'visitor'
}


export const contextNames = {
    ...EFeature1Context
}

export type TContextName = keyof typeof contextNames
export type TFeatureName = 'edulla-chat' | 'edulla-chat-start'

export const logLevel = 'error'

/** Picks the console method that matches the level, so informational events
 *  (e.g. the welcome screen's "Submitting form") do not show up as console
 *  errors in production. Unknown levels stay on `console.error` to be safe. */
export function consoleMethodFor(level: string): 'error' | 'warn' | 'info' | 'debug' {
    switch (level) {
        case 'warn':
        case 'warning':
            return 'warn';
        case 'info':
            return 'info';
        case 'debug':
            return 'debug';
        default:
            return 'error';
    }
}

export function log(
    featureName: TFeatureName,
    errorMessage: string,
    contextName: TContextName,
    properties: object,
    level: string = logLevel,
) {
    console[consoleMethodFor(level)](`[${featureName}] ${errorMessage}`, {
        context: contextName,
        level,
        ...properties,
    })
}

const debugEnabled = process.env.REACT_APP_DEBUG === 'true';

export function debug(namespace: string, data?: object) {
    if (!debugEnabled) return;
    console.debug(`[${namespace}]`, data ?? '');
}
